import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product, index = 0 }) => {
  const objectPosition = product.image_position || "center";
  return (
    <Link
      to={`/shop/${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(index * 0.08, 0.6)}s` }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative overflow-hidden bg-[#efe6db] aspect-[3/4]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="img-zoom w-full h-full object-cover"
          style={{ objectPosition }}
        />
      </div>
      <div className="mt-5 flex justify-between items-start">
        <div>
          <h3 className="font-serif text-xl leading-tight">{product.name}</h3>
          <p className="text-xs text-[#1a1814]/60 mt-1 italic">{product.tagline}</p>
        </div>
        <div className="font-serif text-lg text-[#1a1814] whitespace-nowrap ml-4">
          £{product.price.toFixed(0)}
        </div>
      </div>
    </Link>
  );
};
